<template>
  <BannerBlock
    image-url="https://japhy-assets.twic.pics/download?id=1V-KKx0OihoyKA9CE0o94x4Bjtui4eQH_"
  >
    <template #title>
      {{ $i18n('Vous nous manquez !') }}
    </template>

    <template #content>
      {{
        $i18n(
          "Pour profiter d'un abonnement Japhy sans interruption, nous vous invitons à vérifier vos informations ou à contacter notre service client.",
        )
      }}
      <Link :link="`tel:${CONTACT_PHONE_NUMBER}`" :class="$style.link">
        <Button appearance="smallSecondary" :class="$style.contactButton">
          <template #leftIcon><Icon name="phone" /></template>

          <Typography variant="bodySmallBold">
            {{ formattedPhoneNumber }}
          </Typography>
        </Button>
      </Link>
    </template>
  </BannerBlock>
</template>

<script>
import { CONTACT_PHONE_NUMBER } from '@front/common/constants'
import { BannerBlock, Button, Icon, Typography } from '@front/ui'
import { computed, defineComponent } from '@vue/composition-api'
import {
  formatIncompletePhoneNumber,
  parsePhoneNumber,
} from 'libphonenumber-js'

import Link from './Link.vue'

export default defineComponent({
  components: { Button, Icon, Typography, BannerBlock, Link },
  setup() {
    const formattedPhoneNumber = computed(() => {
      const { number } = parsePhoneNumber(CONTACT_PHONE_NUMBER, 'FR')
      const formattedNumber = formatIncompletePhoneNumber(number)

      return formattedNumber
    })

    return { formattedPhoneNumber, CONTACT_PHONE_NUMBER }
  },
})
</script>

<style lang="scss" module>
.contactButton {
  min-width: auto;
}
</style>
